module.exports = __webpack_public_path__ + "static/img/Schedule-amico.3266921.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Schedule-amico.svg
// module id = CI69
// module chunks = 1